import * as Yup from "yup";

export const designationSchema = Yup.object({
    designation: Yup.string().required(" Enter Designation"),
    status: Yup.string().required("Select Status"),
    // password: Yup.string().required(" Enter Password"),
});
